import { useNavigate } from 'react-router-dom';
import Page from '../components/Page';
import { useAppStore } from '../stores/useAppStore';
import GradientArrow from '../components/GradientArrow';



function PageOutcomeEnterprise() {
  const { menuItems } = useAppStore();
  const navigate = useNavigate();

  return (
    <Page className="pt-846u pr-258u pb-261u relative">
        <div className='absolute top-257u left-1/2 text-100u font-extralight -translate-x-1/2 z-30'>Outcomes for enterprise</div>
        <div className='absolute left-1/2 -translate-x-1/2 top-445u w-[50%] text-center'>
              <div className='text-52u font-light leading-72u mb-154u'>Cisco powers how people and technology work together across the physical and digital worlds.</div>
              <div className='text-42u font-light leading-none text-[#A9AAB5]'>Tap an outcome below to learn more.</div>
        </div>
        <div className='flex flex-col relative border-3u border-[#C7C8D3] rounded-120u pt-80u px-90u pb-86u ml-[8.625rem]'>
            <div className='flex h-248u gap-128u'>
              <div
                className='w-full h-full rounded-full border-3u border-[rgba(199,200,211,0.22)] flex flex-col justify-center items-center gap-20u click-effect bg-[#0E2242]'
                onClick={() => navigate(`/${menuItems[2].key}/${menuItems[2].children[0].key}`)}
                >
                <span className='font-light text-64u leading-none'>AI-Ready Data Centers</span>
                <span className='font-light text-32u leading-none'>Transform data centers to power AI workloads anywhere.</span>
              </div>
              <div
                className='w-full h-full rounded-full border-3u border-[rgba(199,200,211,0.22)] flex flex-col justify-center items-center gap-20u click-effect bg-[#0E2242]'
                onClick={() => navigate(`/${menuItems[2].key}/${menuItems[2].children[1].key}`)}
                >
                <span className='font-light text-64u leading-none'>Future-Proofed Workplaces</span>
                <span className='font-light text-32u leading-none'>Modernize everywhere people work and serve customers.</span>
              </div>
            </div>
            <div className='text-center flex items-center px-72u pt-104u pb-91u'>
                <div className="flex-1 flex items-center">
                    <div className="flex-shrink-0 w-0 h-0 border-t-[1rem] border-t-transparent border-b-[1rem] border-b-transparent border-r-[1.7rem] border-r-orange"></div>
                    <div className="flex-1 h-4u
                    bg-[linear-gradient(to_left,#07182D,#0A60FF,#06b6d4,#d946ef,#f97316)]
                    "></div>
                </div>
                <div className='flex-shrink-0 text-52u font-light leading-none'>Secure global connectivity</div>
                <div className="flex-1 flex items-center">
                    <div className="flex-1 h-[0.25rem] bg-[linear-gradient(to_right,#07182D,#0A60FF,#06b6d4,#d946ef,#f97316)]"></div>
                    <div className="flex-shrink-0 w-0 h-0 border-t-[1rem] border-t-transparent border-b-[1rem] border-b-transparent border-l-[1.7rem] border-l-orange"></div>
                </div>
            </div>
            <div className='w-full pt-81u pb-100u rounded-full relative
            flex flex-col justify-center items-center
            border-3u border-[rgba(199,200,211,0.22)]
            click-effect bg-[#0E2242]'
            onClick={() => navigate(`/${menuItems[2].key}/${menuItems[2].children[2].key}`)}>
                
                    <span className='font-light text-64u leading-none mb-28u'>Digital Resilience</span>
                    <span className='font-light text-32u leading-[3.625rem] text-center'>Keep your organization secure, reliable, and performing with game-changing security, assurance, and observability across the entire digital footprint.</span>

              <div className='
              absolute h-[4.375rem] left-1/2 bottom-0 flex items-center -translate-x-1/2 translate-y-1/2
              '>
                <GradientArrow className="h-60u" />
                <span className='flex-shrink-0 font-extralight text-24u leading-none uppercase tracking-[0.4rem]'>Accelerated by Cisco AI</span>
                <GradientArrow className="h-60u -scale-100" />
              </div>
            </div>
          <div>
            
          </div>
      </div>
    </Page>
  );
}

export default PageOutcomeEnterprise;